var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"link-lists"},_vm._l((_vm.links),function(link){return _c('div',{key:link.key},[_c('LinkItem',{attrs:{"item":link,"existingTags":_vm.existingTags}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }